function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M88 64.1111C88 66.2034 87.1667 68.2099 85.6835 69.6894C84.2002 71.1688 82.1885 72 80.0909 72H8.90909C6.81147 72 4.79976 71.1688 3.31652 69.6894C1.83328 68.2099 1 66.2034 1 64.1111V20.7222C1 18.63 1.83328 16.6234 3.31652 15.1439C4.79976 13.6645 6.81147 12.8333 8.90909 12.8333H24.7273L32.6364 1H56.3636L64.2727 12.8333H80.0909C82.1885 12.8333 84.2002 13.6645 85.6835 15.1439C87.1667 16.6234 88 18.63 88 20.7222V64.1111Z",
  stroke: "#999999",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M44.5 56.2222C53.2361 56.2222 60.3182 49.1583 60.3182 40.4444C60.3182 31.7306 53.2361 24.6667 44.5 24.6667C35.7639 24.6667 28.6818 31.7306 28.6818 40.4444C28.6818 49.1583 35.7639 56.2222 44.5 56.2222Z",
  stroke: "#999999",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgPhoto = function SvgPhoto(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 73,
    viewBox: "0 0 89 73",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhoto, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/photo.faa26fb9.svg";
export { ForwardRef as ReactComponent };